export const MINI_CHROME_WIN_VERSION = 88;
export const MINI_CHROME_MACOS_VERSION = 74;
export const MINI_CHROME_IOS_VERSION = 74;
export const MINI_CHROME_ANDROID_VERSION = 74;
export const MINI_CHROME_OTHER_VERSION = 74;
export const MINI_IE_VERSION = 11;
export const MINI_EDGE_VERSION = 18;
export const MINI_SAFARI_VERSION = 12;
